import Component from '../abstracts/Component';

export default class HeaderComponent extends Component {

  get SELECTORS() {
    return {
      mainHeader: '[data-main-header]',
      hamburgerIcon: '[data-hamburger-icon]',
      searchIcon: '[data-trigger-search]',
      benefitBar: '[data-benefit-bar]',
      menuContainer: '[data-menu-container]',
      menuLink: '[data-menu-item]',
      submenuLink: '[data-menu-submenu]',
      submenuContainer: '[data-nav-level="2"]',
      submenuWrapper: '[data-item-parent-name]',
      submenuMobileBack: '[data-subnav-mobile-back]',
      submenuMobileTitle: '[data-subnav-mobile-title]',
      searchBar: '[data-js-component="SearchLayerComponent"]',
      pageWrapper: '#page-wrapper',
      menuWrapper: '[data-menu-wrapper]',
      wishlistCounter: '[data-wishlist-qty]',
      shortcutPromo: '[data-js-component="ShortcutPromoComponent"]'
    };
  }

  readDOM() {
    return {
      mainHeader: this.$component.querySelector(this.SELECTORS.mainHeader),
      hamburgerIcon: this.$component.querySelector(this.SELECTORS.hamburgerIcon),
      searchIcon: this.$component.querySelector(this.SELECTORS.searchIcon),
      benefitBars: document.querySelectorAll(this.SELECTORS.benefitBar),
      menuContainer: this.$component.querySelector(this.SELECTORS.menuContainer),
      menuLinks: this.$component.querySelectorAll(this.SELECTORS.menuLink),
      submenuWrappers: this.$component.querySelectorAll(this.SELECTORS.submenuWrapper),
      submenuLinks: this.$component.querySelectorAll(this.SELECTORS.submenuLink),
      submenuContainer: this.$component.querySelector(this.SELECTORS.submenuContainer),
      submenuMobileBack: this.$component.querySelector(this.SELECTORS.submenuMobileBack),
      submenuMobileTitle: this.$component.querySelector(this.SELECTORS.submenuMobileTitle),
      searchBar: this.$component.querySelector(this.SELECTORS.searchBar),
      activeMenuItem: null,
      activeSubmenuItem: null,
      isHeaderTransparent: this.$component.dataset.transparent == 'true' ? true : false,
      menuWrapper: this.$component.querySelector(this.SELECTORS.menuWrapper),
      wishlistCounter: this.$component.querySelectorAll(this.SELECTORS.wishlistCounter),
      shortcutPromos: document.querySelectorAll(this.SELECTORS.shortcutPromo)
    };
  }

  get CSS_CUSTOMVARS() {
    return {
      headerHeight: '--js-header-height',
      jsVh: '--vh',
      navLevel2Height: '--js-nav-level-2-height',
      benefitBarHeight: '--js-benefitBar-height'
    };
  }

  constructor(htmlEl) {
    super(htmlEl);
    this.headerHeight = 0;
    this.navLevel2Height = 0;
    this.benefitBarHeight = 0;
    this.isScrollingBlocked = false;
  }

  // handle mobile menu
  handleMobileMenu() {
    this.dom.hamburgerIcon.addEventListener('click', () => {
      // check if menu is open
      const isOpen = this.dom.menuContainer.classList.contains('--opened');
      // toggle menu state
      this.toggleHamburgerMenu(isOpen);
      // close search layer if menu is closed
      if (!this.dom.menuContainer.classList.contains('--opened')) {
        this.closeSearchLayer(this.dom.searchIcon);
      }
    });
    //handle submenu links
    this.dom.submenuLinks?.forEach((submenuLink) => {
      submenuLink.addEventListener('click', (event) => {
        event.preventDefault();
        const parentName = event.currentTarget.dataset.menuItem;
        if (this.dom.submenuContainer) {
          //get the right submenu section
          const submenu = this.dom.submenuContainer.querySelector(
            `[data-item-parent-name='${parentName}']`
          );
          //submenu found open it
          if (submenu) {
            submenu.classList.add('--show');
            //assign submenu title
            this.dom.submenuMobileTitle.innerHTML = parentName;
            this.dom.submenuContainer.classList.add('--opened');
            this.dom.menuWrapper.scrollTop = 0;
          }
        }
      });
    });
    //handle submenu hide on back click
    this.dom.submenuMobileBack?.addEventListener('click', () => {
      this.dom.submenuContainer.classList.remove('--opened');
      this.dom.menuWrapper.scrollTop = 0;
      this.dom.submenuContainer
        .querySelectorAll('[data-item-parent-name]')
        .forEach((submenu) => submenu.classList.remove('--show'));
    });
  }

  openSubMenuByPosition(){
    const activeEl = this.dom.submenuContainer.querySelector('[data-active="true"]')
    if (activeEl) {
      //get the right submenu section
      const parentName = activeEl.parentElement.dataset.itemParentName
      const submenu = this.dom.submenuContainer.querySelector(
        `[data-item-parent-name='${parentName}']`
      );
      //submenu found open it
      if (submenu) {
        submenu.classList.add('--show');
        //assign submenu title
        this.dom.submenuMobileTitle.innerHTML = parentName;
        this.dom.submenuContainer.classList.add('--opened');
        this.dom.menuWrapper.scrollTop = 0;
      }
    }
  }

  //handle desktop pre opened menu depending on page
  handleDesktopMenu() {
    //loop menu voices to gather the active one to enable correct submenu
    if(this.dom.menuLinks && this.dom.menuLinks.length > 0) {
      this.dom.menuLinks.forEach(menuLink => {
        if(menuLink.classList.contains("--open")) {
          this.dom.activeMenuItem = menuLink;
          if(this.dom.submenuWrappers && this.dom.submenuWrappers.length > 0) {
            this.dom.submenuWrappers.forEach(submenuWrapper => {
              if(submenuWrapper.dataset.itemParentName === menuLink.dataset.menuItem) {
                this.dom.activeSubmenuItem = submenuWrapper;
                submenuWrapper.classList.add("--show");
              }
            });
          }
        }
      });
      //handle click on menu link with submenu activation
      this.dom.menuLinks.forEach(menuLink => {
        menuLink.addEventListener("click", event => {
          menuLink.classList.add("--open");
          this.dom.activeMenuItem ? this.dom.activeMenuItem.classList.remove("--open") : '';
          this.dom.activeMenuItem = menuLink;
          if(this.dom.submenuWrappers && this.dom.submenuWrappers.length > 0) {
            this.dom.submenuWrappers.forEach(submenuWrapper => {
              if(submenuWrapper.dataset.itemParentName === menuLink.dataset.menuItem) {
                // I block the scroll to prevent the variable calculation from being incorrect
                this.isScrollingBlocked = true;
                if(this.dom.activeSubmenuItem) {
                  this.dom.activeSubmenuItem.classList.remove("--show");
                }
                this.dom.submenuContainer.classList.remove('--collapsed');
                this.$component.classList.remove('short');
                submenuWrapper.classList.add("--show");
                this.dom.activeSubmenuItem = submenuWrapper;
                // Unlock the scroll and update heights after the opacity transition (defined in CSS) ends
                submenuWrapper.addEventListener('transitionend', () => {
                  this.updateStylesAndHeights();
                  this.isScrollingBlocked = false;
                });
              }
            });
          }
        });
      });
    }
  }

  handleSearchIcon() {
    if(this.dom.searchIcon) {
      //handle mobile
      if(window.matchMedia('(max-width: 1023px)').matches) {
        this.dom.searchIcon.addEventListener("click", event => {
          // Check if the search layer is open
          const currentState = event.currentTarget.dataset.triggerSearch;
          const isOpen = currentState === 'open';
          // Toggle menu state
          this.toggleHamburgerMenu(isOpen);
          this.toggleSearchLayer(event.currentTarget, isOpen);
        });
      }
      //handle desktop
      if(window.matchMedia('(min-width: 1024px)').matches) {
        this.dom.searchIcon.addEventListener("click", event => {
          this.$emit(this.$customEvents.SEARCH_LAYER_EVENTS.open);
          this.$emit(this.$customEvents.HEADER_EVENTS.disableTransparent);
        });
      }
    }
  }

  //listen scroll desktop for transparent header
  handleTransparentHeader() {
    if(this.dom.isHeaderTransparent) {
      const headerMarginTop = '-' + this.headerHeight + 'px';
      const pageWrapper = document.querySelector(this.SELECTORS.pageWrapper);
      pageWrapper.style.marginTop = headerMarginTop;

      //handle page scroll
      document.addEventListener("scroll", event => {
        if (window.scrollY > 0) {
          this.$component.classList.remove("--transparent");
        } else {
          if(!document.body.classList.contains("--no-overflow")) {
            this.$component.classList.add("--transparent");
          }
        }
      });
      // enable --transparent
      this.$on(this.$customEvents.HEADER_EVENTS.enableTransparent, event => {
        this.$component.classList.add("--transparent");
      });
      // disable --transparent
      this.$on(this.$customEvents.HEADER_EVENTS.disableTransparent, event => {
        this.$component.classList.remove("--transparent");
      });
    }
  }

  calcElementHeights() {
    this.headerHeight = this.$component ? this.$component.offsetHeight : 0;
    this.navLevel2Height = this.dom.submenuContainer ? this.dom.submenuContainer.offsetHeight : 0;
    this.benefitBarHeight = this.dom.benefitBars[0] ? this.dom.benefitBars[0].offsetHeight : 0;
  }

  calcNavHeight() {
    if (window.matchMedia('(max-width: 1023px)').matches) {
      //set menu height
      const headerMenuHeight = this.dom.mainHeader.offsetHeight;
      const navbarHeight = window.innerHeight - headerMenuHeight;
      this.dom.menuContainer.style.height = navbarHeight + 'px';
    } else {
      this.dom.menuContainer.style.height = 'auto';
    }
  }

  bindResizeEvents() {
    this.updateStylesAndHeights();
    this.calcNavHeight();
    window.addEventListener('resize', () => {
      this.updateStylesAndHeights();
      this.calcNavHeight();
    });
  }

  setCustomVar() {
    const root = document.documentElement;
    const vh = window.innerHeight * 0.01;
    root.style.setProperty(this.CSS_CUSTOMVARS.jsVh, `${vh}px`);
    root.style.setProperty(this.CSS_CUSTOMVARS.headerHeight, `${this.headerHeight}px`);
    root.style.setProperty(this.CSS_CUSTOMVARS.navLevel2Height, `${this.navLevel2Height}px`);
    root.style.setProperty(this.CSS_CUSTOMVARS.benefitBarHeight, `${this.benefitBarHeight}px`);
  }

  startScroll() {
    window.addEventListener('scroll',  (e) => {
      if (this.isScrollingBlocked) {
        return;
      }
      this.handleScroll();
    });
  }

  handleScroll() {
    this.setHeaderStatus(this);
    requestAnimationFrame(() => {
      this.updateStylesAndHeights();
      this.isScrollingBlocked = false;
    });
  }

  updateStylesAndHeights() {
    this.calcElementHeights();
    this.setCustomVar();
  }

  setHeaderStatus(_this) {
    //
    if ( window.scrollY > 0 ) {
      // collapse the submenu
      _this.dom.submenuContainer.classList.add('--collapsed');
      _this.$component.classList.add('short');
    } else  {
      _this.dom.submenuContainer.classList.remove('--collapsed');
      _this.$component.classList.remove('short');
    }
  }

  updateWishlistCounter(qty) {
    if(this.dom.wishlistCounter) {
      this.dom.wishlistCounter.forEach(counter => {
        if (parseInt(qty, 10) > 0) {
          counter.dataset.wishlistQty = qty;
          counter.classList.remove("hidden", "--show");
          counter.classList.add("--go-up");
          counter.textContent = qty;
          //set new counter
          setTimeout(() => {
            counter.dataset.wishlistQty = qty;
            counter.textContent = qty;
            counter.classList.remove("--go-up");
            counter.classList.add("--go-down");
            setTimeout(() => {
              counter.classList.remove("--go-down");
              counter.classList.add('--show');
            },300);
          },300);
        } else {
          counter.classList.add("hidden");
          counter.textContent = '';
        }
      });
    }
  }

  closeSearchLayer(triggerElement) {
    triggerElement.dataset.triggerSearch = 'closed';
    this.$emit(this.$customEvents.SEARCH_LAYER_EVENTS.close);
  }

  toggleSearchLayer(triggerElement, isOpen) {
    if (isOpen) {
      this.closeSearchLayer(triggerElement);
    } else {
      triggerElement.dataset.triggerSearch = 'open';
      this.$emit(this.$customEvents.SEARCH_LAYER_EVENTS.open);
    }
  }

  toggleHamburgerMenu(shouldClose) {
    // Show/hide benefit bars
    this.dom.benefitBars?.forEach((benefitBar) => {
      benefitBar.classList.toggle('--hidden', !shouldClose);
    });
    // Show/hide shortcut promos
    this.dom.shortcutPromos?.forEach((shortcutPromo) => {
      shortcutPromo.classList.toggle('--hidden', !shouldClose);
    });
    // Animate hamburger icon
    this.dom.hamburgerIcon.classList.toggle('--opened', !shouldClose);
    // Lock/unlock body scroll
    document.body.classList.toggle('--no-overflow', !shouldClose);
    this.dom.menuContainer.classList.toggle('--opened', !shouldClose);

    // Handle header transparency
    const menuIsOpen = this.dom.menuContainer.classList.contains('--opened');

    if (menuIsOpen) {
      this.$emit(this.$customEvents.HEADER_EVENTS.disableTransparent);
    } else {
      this.$emit(this.$customEvents.HEADER_EVENTS.enableTransparent);
    }
    this.$emit(this.$customEvents.HEADER_EVENTS.menuOpen, menuIsOpen);
    // Reset scroll
    this.dom.menuWrapper.scrollTop = 0;
  }

  bindEvents() {
    if (window.matchMedia('(max-width: 1023px)').matches) {
      this.handleMobileMenu();
    }
    if (window.matchMedia('(min-width: 1024px)').matches) {
      this.handleDesktopMenu();
    }
    this.$on(this.$customEvents.PRODUCT_EVENTS.addedtowish+'.mmfg '+this.$customEvents.PRODUCT_EVENTS.removedfromwish, ({ event, payload }) => {
      this.updateWishlistCounter(payload.qty);
    });
    this.handleSearchIcon();
    this.bindResizeEvents();
    this.startScroll();
    this.$on(this.$customEvents.HEADER_EVENTS.menuOpen, () => {
      this.openSubMenuByPosition()
    })
  }

  render() {
    super.render();
    this.dom = this.readDOM();
    this.bindEvents();
    this.handleTransparentHeader();
  }
}
